
import Vue from "vue";
import CompanyScopeSelect from "./CompanyScopeSelect.vue";

const SUMMARY_PROMPT =
  "สรุปข้อมูลของโมเดลทั้งหมดที่อยู่ในระบบ หากมีการส่งชื่อบริษัทไปด้วย ให้สรุปข้อมูลของโมเดลที่เกี่ยวข้องกับบริษัทนั้นเท่านั้น";

export default Vue.extend({
  name: "ChatComposer",
  components: { CompanyScopeSelect },
  props: {
    companyId: {
      type: Number as () => number | null,
      default: null,
    },
    companies: {
      type: Array as () => any[],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prefill: {
      type: String,
      default: "",
    },
  },
  data() {
    return { text: "" };
  },
  watch: {
    prefill(val: string) {
      if (val) {
        this.text = val;
        this.$nextTick(() => this.autoResize());
        this.$emit("prefill-consumed");
      }
    },
  },
  methods: {
    autoResize() {
      const ta = this.$refs.textarea as HTMLTextAreaElement;
      if (!ta) return;
      ta.style.height = "auto";
      ta.style.height = Math.min(ta.scrollHeight, 120) + "px";
    },
    fillSummary() {
      this.text = SUMMARY_PROMPT;
      this.$nextTick(() => this.autoResize());
    },
    handleSend() {
      const trimmed = this.text.trim();
      if (!trimmed || this.disabled) return;
      this.$emit("send", trimmed);
      this.text = "";
      this.$nextTick(() => this.autoResize());
    },
  },
});
